import * as React from 'react'
import { Link } from 'react-router'
import { SignupHeader } from './auth/headers/SignupHeader'
import { ErrorPanel } from './auth/errors/ErrorPanel'

const NotFoundView = () => (
  <div className='auth-container'>
    <SignupHeader hideAccountCreation />
    <ErrorPanel variant='danger' icon='bi-x-octagon' title='Page not found' text='This link may be broken or out of date. Check the address and try again.'>
      <Link to='/login' className='auth-link-text'>
        Back to log in
      </Link>
    </ErrorPanel>
  </div>
)

export default NotFoundView
